export default "__VITE_ASSET__BEo1KbTy__"